import { render, staticRenderFns } from "./EventPay.vue?vue&type=template&id=523fb184"
import script from "./EventPay.vue?vue&type=script&lang=js"
export * from "./EventPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports